/* Scope to each section instance */
document.addEventListener('DOMContentLoaded', function(){
  document.querySelectorAll('.island-explorer-section').forEach(function(section){
    const sectionId = section.getAttribute('data-section-id');
    const tabs = section.querySelectorAll('.island-tab');
    const contents = section.querySelectorAll('.island-content');
    const cta = section.querySelector('#island-explorer-cta-'+sectionId+' .shop-button');

    // Tabs
    tabs.forEach(function(tab){
      tab.addEventListener('click', function(e){
        e.preventDefault(); e.stopPropagation();
        const islandId = this.getAttribute('data-island');
        tabs.forEach(function(t){ t.classList.remove('active'); t.style.background='#fff'; t.style.color='#8B4513'; });
        this.classList.add('active'); this.style.background='#8B4513'; this.style.color='#fff';
        contents.forEach(function(c){ c.style.display='none'; stopCarousel(c.getAttribute('data-island-content')); });
        const selected = section.querySelector('[data-island-content="'+islandId+'"]');
        if(selected){ selected.style.display='grid'; initCarousel(islandId); }
      });
    });

    // Read more
    section.querySelectorAll('.read-more-btn').forEach(function(btn){
      btn.addEventListener('click', function(e){
        e.preventDefault();
        const id = this.getAttribute('data-toggle');
        const exp = section.querySelector('[data-expandable="'+id+'"]');
        if(!exp) return;
        if (exp.style.maxHeight === '0px' || exp.style.maxHeight === '') {
          exp.style.maxHeight = exp.scrollHeight + 'px'; this.textContent = 'Read Less';
        } else { exp.style.maxHeight = '0'; this.textContent = 'Read More'; }
      });
    });

    // Carousel store
    const carousels = {};

    function setCtaFromIndex(id, i){
      const infoWrap = section.querySelector('[data-product-info="'+id+'"]');
      const infoSlides = infoWrap ? infoWrap.querySelectorAll('.product-info-slide') : [];
      const active = infoSlides[i];
      if(!cta || !active) return;
      const url = active.getAttribute('data-product-url');
      const available = active.getAttribute('data-available') === 'true';
      const defaultLabel = cta.getAttribute('data-default') || cta.textContent.trim();
      if (available && url){
        cta.setAttribute('href', url);
        cta.classList.remove('is-disabled');
        cta.removeAttribute('aria-disabled');
        cta.textContent = defaultLabel;
      } else {
        cta.setAttribute('href', '#');
        cta.classList.add('is-disabled');
        cta.setAttribute('aria-disabled','true');
        cta.textContent = 'Coming Soon';
      }
    }

    function initCarousel(id){
      const track = section.querySelector('[data-track="'+id+'"]');
      const slides = track ? track.querySelectorAll('.carousel-slide') : [];
      const prevBtn = section.querySelector('[data-carousel-control="'+id+'"][data-direction="prev"]');
      const nextBtn = section.querySelector('[data-carousel-control="'+id+'"][data-direction="next"]');
      const infoWrap = section.querySelector('[data-product-info="'+id+'"]');
      if (slides.length === 0) return;
      stopCarousel(id);
      if (!carousels[id]) { carousels[id] = { currentIndex: 0, totalSlides: slides.length, interval: null }; }

      function updateCarousel(index){
        carousels[id].currentIndex = index;
        if(track) track.style.transform = 'translateX(-'+(index*100)+'%)';
        if (infoWrap){
          const infoSlides = infoWrap.querySelectorAll('.product-info-slide');
          infoSlides.forEach(function(s,i){ s.style.display = i===index ? 'block' : 'none'; });
        }
        setCtaFromIndex(id, index);
      }
      function nextSlide(){ updateCarousel((carousels[id].currentIndex + 1) % carousels[id].totalSlides); }
      function prevSlide(){ updateCarousel((carousels[id].currentIndex - 1 + carousels[id].totalSlides) % carousels[id].totalSlides); }

      if (nextBtn) { const n = nextBtn.cloneNode(true); nextBtn.parentNode.replaceChild(n, nextBtn); n.addEventListener('click', function(e){ e.preventDefault(); nextSlide(); startAutoPlay(); }); }
      if (prevBtn) { const p = prevBtn.cloneNode(true); prevBtn.parentNode.replaceChild(p, prevBtn); p.addEventListener('click', function(e){ e.preventDefault(); prevSlide(); startAutoPlay(); }); }

      function startAutoPlay(){ stopCarousel(id); carousels[id].interval = setInterval(nextSlide, 4000); }
      updateCarousel(0);
      startAutoPlay();
    }

    function stopCarousel(id){
      if (carousels[id] && carousels[id].interval) { clearInterval(carousels[id].interval); carousels[id].interval = null; }
    }

    // block clicks on disabled CTA
    if(cta){ cta.addEventListener('click', function(e){ if(this.classList.contains('is-disabled')){ e.preventDefault(); e.stopPropagation(); } }); }

    // Eagerly load visible images in this section
    section.querySelectorAll('img').forEach(function(img){ img.loading='eager'; img.decoding='sync'; img.setAttribute('fetchpriority','low'); });

    // Init first island
    const firstIsland = section.querySelector('.island-tab')?.getAttribute('data-island');
    if (firstIsland) initCarousel(firstIsland);
  });
});
